import React from 'react';
import { Box, Skeleton, SxProps, Theme } from '@mui/material';
import { SearchFieldBone } from '../../molecules/SearchFieldBone/SearchFieldBone';
import { TableGridBone } from '../../organisms/TableGridBone/TableGridBone';

interface ListSkeletonProps {
    /** Nombre de colonnes */
    columns?: number;
    /** Nombre de lignes */
    rows?: number;
    /** Afficher la recherche */
    showSearch?: boolean;
    /** Afficher un panneau de preview à droite */
    showPreview?: boolean;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

/**
 * Skeleton pour les pages de listing.
 * Affiche une grille de chargement avec optionnellement une recherche et un panneau de preview.
 */
export const ListSkeleton: React.FunctionComponent<ListSkeletonProps> = function ({
    columns = 4,
    rows = 8,
    showSearch = true,
    showPreview = false,
    sx = {},
}) {
    const listContent = (
        <>
            {showSearch && <SearchFieldBone />}
            <TableGridBone
                columns={columns}
                rows={rows}
                withHeader
            />
        </>
    );

    const listContainerStyles: SxProps<Theme> = {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: '95%',
        width: showPreview ? '100%' : '95%',
    };

    if (!showPreview) {
        return <Box sx={{ ...listContainerStyles, ...sx }}>{listContent}</Box>;
    }

    return (
        <Box sx={{ display: 'flex', gap: 2, ...sx }}>
            <Box sx={{ ...listContainerStyles, width: '70%' }}>{listContent}</Box>

            <Box sx={{ width: '30%' }}>
                <Skeleton
                    variant="rounded"
                    height={400}
                    sx={{ borderRadius: 2 }}
                />
            </Box>
        </Box>
    );
};
